import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import {
    Checkbox,
    RadioGroup,
    Radio,
    FormHelperText,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import format from 'date-fns/format';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import WrapperContainer from '../../../components/Container/WrapperContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTypography from '../../../components/Typography/CustomTypography';
import CleanableInput from '../../../components/Input/CleanableInput';
import DateRanger from '../../../components/DatePicker/DateRanger';
import TimeRanger from '../../../components/DatePicker/TimeRanger';
import Validation from '../../../common/Validation';
import eventDialogStyle from '../../../assets/jss/pages/eventDialogStyle';
import UploadButton from '../../../components/Button/UploadButton';
import FormDialog from '../../../components/Dialog/FormDialog';
import Button from '../../../components/Button/CustomButton';
import SnackBar from '../../../components/Snackbar/Snackbar';
import EventZone from './Form/EventZone';
import { FREE_LOGIN, Role, LIST_LANGUAGE } from '../../../common/Constants';
import ObjectHelper from '../../../common/helper/ObjectHelper';

const useStyles = makeStyles(eventDialogStyle);

const SPACE = 32;
const TAB = 9;
const ENTER = 13;

export default function EventDialog(props) {
    const {
        createSuccess,
        createErrors,
        editSuccess,
        editErrors,
        getDetailEvent: eventDetail,
        fetchCreateEvent,
        fetchEditEvent,
        fetchClearCreateEvent,
        fetchClearEditEvent,
        fetchGetDetailEvent,
        eventId,
        eventShortName,
        isOpen,
        handleClose,
        fetchEventZones,
        clearEventZone,
        eventZones,
        dataAccount,
        role,
        fetchClearGetDetailEvent,
    } = props;

    const classes = useStyles();
    const defaultParams = {
        eventName: '',
        shortName: '',
        sdate: format(new Date(), 'yyyy-MM-dd'),
        edate: format(new Date(), 'yyyy-MM-dd'),
        opentime: format(new Date().getTime(), 'H:mm'),
        closetime: format(new Date().getTime(), 'H:mm'),
        smallzone: false,
        bigzone: false,
        standardzone: false,
        grandZone: false,
        address: '',
        description: '',
        hasExhibition: '1',
        hasSeminar: '1',
        hasLiveStream: '1',
        price_live_stream: 0,
        displayLiveStream: '0',
        displayExhibition: '0',
        displaySeminar: '0',
        free_exhibition: '0',
        free_seminar: '0',
        free_live_stream: '0',
        displayAds: '0',
        maxVideoTimeExhibition: '',
        maxAudioTimeExhibition: '',
        maxVideoTimeSeminar: '',
        maxAudioTimeSeminar: '',
        zones: [{ id: null, zone_name: '' }],
        freeLogin: FREE_LOGIN.DISABLE_ALL.CODE,
        outer_server_activation: '',
        has_shopping_cart: '1',
        hasCustom: '0',
        layoutExhibition: 0,
        layoutSeminar: 0,
        layoutLivestream: 0,
        layoutSidebar: 0,
        event_organizer_name: '',
        event_organizer_tel: '',
        event_organizer_email: '',
    };
    const [params, setParams] = useState(defaultParams);
    const [validateResults, setValidateResults] = useState({});
    const [isChangeImage, setChangeImage] = useState(false);
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [autoCompleteValue, setAutoCompleteValue] = useState([]);
    const [autoCompleteValueJobViewer, setAutoCompleteValueJobViewer] = useState([]);
    const [autoCompleteValueOccupationViewer, setAutoCompleteValueOccupationViewer] = useState([]);
    const [autoCompleteValueOccupationOrganizer, setAutoCompleteValueOccupationOrganizer] = useState([]);
    const [autoCompleteValueCate, setAutoCompleteValueCate] = useState([]);
    const [listLanguage, setListLanguage] = useState({});
    const intl = useIntl();

    const seminarValue = { yes: '1', no: '0' };
    const liveStreamValue = { yes: '1', no: '0' };
    const exhibitionsValue = { yes: '1', no: '0' };
    const freeLoginValue = { yes: '1', no: '0' };
    const hasShoppingCart = { yes: '1', no: '0' };
    const layoutExhibitionValue = { layoutFirst: 1, default: 0 };
    const layoutSeminarValue = { layoutFirst: 1, default: 0 };
    const layoutLivestreamValue = { layoutFirst: 1, default: 0 };
    const layoutSidebarValue = { layoutFirst: 1, default: 0 };

    useEffect(() => {
        if (eventId && eventShortName && isOpen) {
            fetchGetDetailEvent(eventId);
            fetchEventZones(eventShortName);
        }
        return () => {
            fetchClearGetDetailEvent();
        };
    }, [eventId, eventShortName, fetchGetDetailEvent, fetchEventZones, isOpen]);

    useEffect(() => {
        if (!_.isEmpty(eventDetail) && isOpen) {
            setParams({
                ...params,
                eventName: eventDetail.name,
                shortName: eventDetail.short_name,
                sdate: eventDetail.sdate,
                edate: eventDetail.edate,
                opentime: eventDetail.open_time,
                closetime: eventDetail.close_time,
                address: eventDetail.address,
                description: eventDetail.description,
                smallzone: eventDetail.small_zone,
                bigzone: eventDetail.big_zone,
                standardzone: eventDetail.standard_zone,
                grandZone: eventDetail.grand_zone,
                image: eventDetail.image,
                note: eventDetail.note,
                hasExhibition: eventDetail.has_exhibition === true ? '1' : '0',
                hasSeminar: eventDetail.has_seminar === true ? '1' : '0',
                isExhibition: eventDetail.has_exhibition,
                isSeminar: eventDetail.has_seminar,
                isLiveStream: eventDetail.has_live_stream,
                hasLiveStream: eventDetail.has_live_stream ? '1' : '0',
                price_live_stream: eventDetail.price_live_stream,
                displayLiveStream: eventDetail.display_live_stream === true ? '1' : '0',
                displayExhibition: eventDetail.display_exhibition === true ? '1' : '0',
                displaySeminar: eventDetail.display_seminar === true ? '1' : '0',
                free_exhibition: eventDetail.free_exhibition === true ? '1' : '0',
                free_seminar: eventDetail.free_seminar === true ? '1' : '0',
                free_live_stream: eventDetail.free_live_stream === true ? '1' : '0',
                displayAds: eventDetail.display_ads === true ? '1' : '0',
                organizationRequestUrl: eventDetail.organization_request_url,
                maxVideoTimeExhibition: eventDetail.max_vtime_exhibition,
                maxAudioTimeExhibition: eventDetail.max_atime_exhibition,
                maxVideoTimeSeminar: eventDetail.max_vtime_seminar,
                maxAudioTimeSeminar: eventDetail.max_atime_seminar,
                freeLogin: eventDetail.free_login || FREE_LOGIN.DISABLE_ALL.CODE,
                outer_server_activation: eventDetail.outer_server_activation ? eventDetail.outer_server_activation : '',
                isShoppingCart: eventDetail.has_shopping_cart,
                has_shopping_cart: eventDetail.has_shopping_cart === true ? '1' : '0',
                hasCustom: eventDetail.has_customize ? '1' : '0',
                layoutExhibition: eventDetail.layout_exhibition,
                layoutSeminar: eventDetail.layout_seminar,
                layoutLivestream: eventDetail.layout_livestream,
                layoutSidebar: eventDetail.layout_sidebar,
                event_organizer_name: eventDetail.event_organizer_name,
                event_organizer_tel: eventDetail.event_organizer_tel,
                event_organizer_email: eventDetail.event_organizer_email,
            });
            let lang1 = {};
            // eslint-disable-next-line no-return-assign
            LIST_LANGUAGE.map((item) => lang1 = { ...lang1, [item.language]: (eventDetail.languages || []).includes(item.language) });
            setListLanguage(lang1);
            setAutoCompleteValue(eventDetail.jobs);
            setAutoCompleteValueJobViewer(eventDetail.jobs_viewer);
            setAutoCompleteValueOccupationViewer(eventDetail?.occupations_viewer || []);
            setAutoCompleteValueOccupationOrganizer(eventDetail?.occupations_organizer || []);
            setAutoCompleteValueCate(eventDetail.category  || []);
        }
        if (_.isEmpty(eventDetail) && isOpen) {
            let lang2 = {};
            // eslint-disable-next-line no-return-assign
            LIST_LANGUAGE.map((item) => lang2 = { ...lang2, [item.language]: false });
            setListLanguage(lang2);
        }
    }, [eventDetail, isOpen]);

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    useEffect(() => {
        if (editSuccess) {
            handleIsClose();
            fetchClearEditEvent();
        } else if (!_.isEmpty(editErrors)) {
            if (editErrors.code === 'BAD_REQUEST') {
                setValidateResults({
                    ...validateResults,
                    ...editErrors,
                });
                setErrorMsg(editErrors.message ? editErrors.message.message : 'エラーが発生しました入力された情報を確認してください');
                setIsOpenSnackBar(true);
                fetchClearEditEvent();
            }
        }
    }, [editSuccess, editErrors, validateResults, fetchClearEditEvent]);

    useEffect(() => {
        if (createSuccess) {
            handleIsClose();
            fetchClearCreateEvent();
        } else if (!_.isEmpty(createErrors)) {
            if (createErrors.code === 'BAD_REQUEST') {
                setValidateResults({
                    ...validateResults,
                    ...createErrors,
                });
                setErrorMsg(createErrors.message ? createErrors.message.message : 'エラーが発生しました入力された情報を確認してください');
                setIsOpenSnackBar(true);
                fetchClearCreateEvent();
            }
        }
    }, [createSuccess, createErrors, validateResults]);

    const handleIsClose = () => {
        setValidateResults({});
        setChangeImage(false);
        clearEventZone();
        handleClose();
        setParams({
            ...defaultParams,
            organizationRequestUrl: '',
        });
        setAutoCompleteValueCate([]);
        setAutoCompleteValue([]);
        setAutoCompleteValueJobViewer([]);
        setAutoCompleteValueOccupationViewer([]);
        setAutoCompleteValueOccupationOrganizer([]);
    };

    const validate = () => {
        const {
            eventName, sdate, edate, opentime, closetime, address, description, smallzone, bigzone, standardzone, grandZone, image, note, organizationRequestUrl,
            maxVideoTimeExhibition, maxAudioTimeExhibition, maxVideoTimeSeminar, maxAudioTimeSeminar, zones,
            outer_server_activation, event_organizer_tel, event_organizer_email, event_organizer_name,
        } = params;

        const validateRules = {
            eventName: [() => Validation.isNotEmpty(eventName),
                () => Validation.validateMaxLength(eventName, 100),
            ],
            address: [() => Validation.isNotEmpty(address)],
            sdate: [() => Validation.isNotEmpty(sdate),
                () => Validation.validateDateFormat(sdate),
            ],
            edate: [() => Validation.isNotEmpty(edate),
                () => Validation.validateDateFormat(edate),
            ],
            rangerDate: [() => Validation.validateDateRanger(sdate, edate)],
            opentime: [() => Validation.isNotEmpty(opentime),
                () => Validation.validateTimeFormat(opentime),
            ],
            closetime: [() => Validation.isNotEmpty(closetime),
                () => Validation.validateTimeFormat(closetime),
            ],
            rangerTime: [() => Validation.validateTimeRanger(opentime, closetime)],
            description: [() => Validation.isNotEmpty(description),
                () => Validation.validateMaxLength(description, 1000),
            ],
            checkBox: [
                params.hasExhibition > 0 ? () => Validation.isAnyCheckboxSelected([smallzone, bigzone, standardzone, grandZone]) : () => { },
            ],
            image: [() => Validation.isNotEmpty(image || eventDetail.image)],
            note: [
                () => Validation.validateMaxLength(note, 255),
            ],
            organization: [() => Validation.isNotEmpty(organizationRequestUrl),
                () => Validation.validateMaxLength(organizationRequestUrl, 255),
                () => Validation.isValidUrl(organizationRequestUrl),
            ],
            zones: [
                () => Validation.validateUniqueZone(zones),
            ],
            event_organizer_tel: [
                () => Validation.validatePhoneNumber(event_organizer_tel.trim()),
            ],
            event_organizer_email: [
                () => Validation.validateEmail(event_organizer_email.trim()),
            ],
            event_organizer_name: [
                () => Validation.validateMaxLength(event_organizer_name, 255),
            ],
            occupation_organizer: [
                () => Validation.validateArr(autoCompleteValueOccupationOrganizer),
            ],
            occupation_viewer: [
                () => Validation.validateArr(autoCompleteValueOccupationViewer),
            ],
            jobs: [
                () => Validation.validateArr(autoCompleteValue),
            ],
            jobs_viewer: [
                () => Validation.validateArr(autoCompleteValueJobViewer),
            ],
        };

        if (eventDetail.outer_server_activation) {
            validateRules.outer_server_activation = [
                () => Validation.isNotEmpty(outer_server_activation),
                () => Validation.validateMaxLength(outer_server_activation, 255),
            ];
        } else {
            validateRules.outer_server_activation = [
                () => Validation.validateMaxLength(outer_server_activation, 255),
            ];
        }

        if (params.hasExhibition === '1') {
            validateRules.maxVideoTimeExhibition = [() => Validation.isNotEmpty(maxVideoTimeExhibition)];
            validateRules.maxAudioTimeExhibition = [() => Validation.isNotEmpty(maxAudioTimeExhibition)];
        }

        if (params.hasSeminar === '1') {
            validateRules.maxVideoTimeSeminar = [() => Validation.isNotEmpty(maxVideoTimeSeminar)];
            validateRules.maxAudioTimeSeminar = [() => Validation.isNotEmpty(maxAudioTimeSeminar)];
        }

        if (params.hasSeminar === '0' && params.hasExhibition === '0' && params.hasLiveStream === '0') {
            validateRules.hasNoApplications = [() => Validation.isNoApplications()];
        }

        const validateResult = Validation.validateAllRules(validateRules);
        if (Object.keys(validateResult).length > 0) {
            setValidateResults(validateResult);
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSetParams = (field, value) => {
        setParams((prevParams) => ({ ...prevParams, [field]: value }));
    };

    const handleChangeValueLanguage = (language, value) => {
        if (language !== 'en' && value) setListLanguage((prevParams) => ({ ...prevParams, [language]: value, en: true }));
        else if (language === 'en' && !value) {
            let lang = {};
            // eslint-disable-next-line no-return-assign
            LIST_LANGUAGE.map((item) => lang = { ...lang, [item.language]: false });
            setListLanguage(lang);
        } else setListLanguage((prevParams) => ({ ...prevParams, [language]: value }));
    };

    const handleUploadImage = (file) => {
        handleSetParams('image', file);
        setChangeImage(true);
    };

    const handleSubmit = () => {
        if (validate()) {
            // eslint-disable-next-line array-callback-return, consistent-return
            const dataLang = Object.fromEntries(Object.entries(listLanguage).filter((item) => { if (item[1]) return item; }));
            let submitData = {
                name: checkUndefined(params.eventName),
                sdate: checkUndefined(params.sdate),
                edate: checkUndefined(params.edate),
                open_time: checkUndefined(params.opentime),
                close_time: checkUndefined(params.closetime),
                small_zone: params.smallzone ? 1 : 0,
                standard_zone: params.standardzone ? 1 : 0,
                big_zone: params.bigzone ? 1 : 0,
                grand_zone: params.grandZone ? 1 : 0,
                address: checkUndefined(params.address),
                note: checkUndefined(params.note),
                description: checkUndefined(params.description),
                has_exhibition: checkUndefined(params.hasExhibition),
                has_seminar: checkUndefined(params.hasSeminar),
                display_exhibition: params.hasExhibition !== '0' ? params.displayExhibition : '0',
                display_seminar: params.hasSeminar !== '0' ? params.displaySeminar : '0',
                display_live_stream: params.hasLiveStream !== '0' ? params.displayLiveStream : '0',
                has_live_stream: params.hasLiveStream,
                price_live_stream: params.price_live_stream,
                display_ads: checkUndefined(params.displayAds),
                ...(params.image && isChangeImage && { image: params.image }),
                organization_request_url: checkUndefined(params.organizationRequestUrl),
                ...(params.maxAudioTimeExhibition && { max_atime_exhibition: params.maxAudioTimeExhibition }),
                ...(params.maxVideoTimeExhibition && { max_vtime_exhibition: params.maxVideoTimeExhibition }),
                ...(params.maxAudioTimeSeminar && { max_atime_seminar: params.maxAudioTimeSeminar }),
                ...(params.maxVideoTimeSeminar && { max_vtime_seminar: params.maxVideoTimeSeminar }),
                category: _.join(autoCompleteValueCate.map((it) => it.trim()), ','),
                jobs: _.join(autoCompleteValue.map((it) => it.trim()), ','),
                jobs_viewer: _.join(autoCompleteValueJobViewer.map((it) => it.trim()), ','),
                occupations_viewer: _.join(autoCompleteValueOccupationViewer.map((it) => it.trim()), ','),
                occupations_organizer: _.join(autoCompleteValueOccupationOrganizer.map((it) => it.trim()), ','),
                outer_server_activation: params.outer_server_activation,
                free_exhibition: params.free_exhibition,
                free_seminar: params.free_seminar,
                free_live_stream: params.free_live_stream,
                has_shopping_cart: params.has_shopping_cart,
                has_customize: params.hasCustom,
                layout_exhibition: params.layoutExhibition,
                layout_seminar: params.layoutSeminar,
                layout_livestream: params.layoutLivestream,
                layout_sidebar: params.layoutSidebar,
                event_organizer_name: checkUndefined(params.event_organizer_name),
                event_organizer_tel: checkUndefined(params.event_organizer_tel),
                event_organizer_email: checkUndefined(params.event_organizer_email),
                ...dataAccount,
            };

            if (!_.isEmpty(dataAccount)) {
                submitData = ObjectHelper.removePropertyByKey('site_custom')(submitData);
            }

            if (eventId !== 0) {
                const eventHasZone = params.zones.some((item) => !_.isNull(item.id));

                if (eventHasZone) {
                    submitData.zones = JSON.stringify(params.zones);
                }

                submitData.id = eventId;

                fetchEditEvent(submitData);
            } else if (eventId === 0) {
                const theLastItem = params.zones.filter((item) => !_.isEmpty(item.zone_name));

                if (theLastItem.length) {
                    submitData.zones = JSON.stringify(theLastItem.map((item) => item.zone_name));
                }
                submitData.languages = _.join(Object.keys(dataLang), ',');

                fetchCreateEvent(submitData);
            }
        }
    };

    const handleKeyPressInput = (e) => {
        if (!/\d/.test(e.key)) e.preventDefault();
    };

    const actionsButton = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                onClick={handleSubmit}
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
            >
                {intl.formatMessage({ id: 'save' })}
            </Button>
            <Button
                autoFocus
                gradient
                onClick={handleIsClose}
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );

    const renderZoneArea = () => {
        if (eventId && _.isEmpty(eventZones)) return null;

        return (
            <GridItem xs={12} md={12} className={classes.item}>
                <EventZone
                    classes={classes}
                    params={params}
                    handleSetParams={handleSetParams}
                    validateResults={validateResults}
                    eventId={eventId}
                />
            </GridItem>
        );
    };

    return (
        <FormDialog title={eventId ? '催し更新' : '催し登録'} isOpen={isOpen} handleClose={handleIsClose} actions={actionsButton()}>
            <WrapperContainer className={classes.wrapper}>
                <GridItem xs={12} md={12} className={(eventId ? classes.item : classes.createItem)}>
                    <div className={classes.leftTitle}>
                        <CustomTypography variant="h5" required bold>
                            催し名
                        </CustomTypography>
                    </div>
                    <div className={(eventId ? classes.rightInput : classes.rightCreate)}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.eventName}
                            size="medium"
                            onChange={(value) => handleSetParams('eventName', value)}
                            error={!!validateResults.eventName}
                            helperText={validateResults.eventName
                                ? intl.formatMessage({ id: validateResults.eventName.message }, { maxLength: 100 }) : ''}
                        />
                    </div>
                </GridItem>
                {
                    eventId !== 0 && (
                        <GridItem xs={12} md={12} className={classes.item}>
                            <div className={classes.leftTitle}>
                                <CustomTypography bold>
                                    催しのURL
                                </CustomTypography>
                            </div>
                            <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                                <a
                                    className={classes.right}
                                    href={`${window.location.origin}/${process.env.REACT_APP_ROOT_PATH}/${eventDetail.short_name}/home`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {`${window.location.origin}/${process.env.REACT_APP_ROOT_PATH}/${eventDetail.short_name}/home`}
                                </a>
                            </div>

                        </GridItem>
                    )
                }
                {(role === +Role.operatorAdmin || role === +Role.masterAdmin) && (
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle}>
                            <CustomTypography bold required>
                                パス名
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput}>
                            <CleanableInput
                                className={classes.rightDisable}
                                defaultValue={params.shortName}
                            />
                        </div>
                    </GridItem>
                )}
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            開催期間
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <DateRanger
                            className={classes.right}
                            defaultStartDate={params.sdate}
                            defaultEndDate={params.edate}
                            onChangeStartDate={(startDate) => handleSetParams('sdate', startDate)}
                            onChangeEndDate={(endDate) => handleSetParams('edate', endDate)}
                            error={{
                                startDate: !!validateResults.sdate,
                                endDate: !!validateResults.edate,
                                rangerDate: !!validateResults.rangerDate,
                            }}
                            helperTexts={{
                                startDate: validateResults.sdate
                                    ? intl.formatMessage({ id: validateResults.sdate.message }) : '',
                                endDate: validateResults.edate
                                    ? intl.formatMessage({ id: validateResults.edate.message }) : '',
                                rangerDate: validateResults.rangerDate
                                    ? intl.formatMessage({ id: validateResults.rangerDate.message }) : '',
                            }}
                        />
                    </div>

                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            開催時間
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <TimeRanger
                            defaultStartTime={eventDetail.open_time ? eventDetail.open_time : format(new Date().getTime(), 'H:mm')}
                            defaultEndTime={eventDetail.close_time ? eventDetail.close_time : format(new Date().getTime(), 'H:mm')}
                            onChangeStartTime={(startTime) => handleSetParams('opentime', startTime)}
                            onChangeEndTime={(endTime) => handleSetParams('closetime', endTime)}
                            error={{
                                startTime: !!validateResults.opentime,
                                endTime: !!validateResults.closetime,
                                rangerTime: !!validateResults.rangerTime,
                            }}
                            helperTexts={{
                                startTime: validateResults.opentime
                                    ? intl.formatMessage({ id: validateResults.opentime.message }) : '',
                                endTime: validateResults.closetime
                                    ? intl.formatMessage({ id: validateResults.closetime.message }) : '',
                                rangerTime: validateResults.rangerTime
                                    ? intl.formatMessage({ id: validateResults.rangerTime.message }) : '',
                            }}
                        />
                    </div>

                </GridItem>

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            備考
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            isMultiline
                            defaultValue={params.note}
                            onChange={(value) => handleSetParams('note', value)}
                            error={!!validateResults.note}
                            helperText={validateResults.note
                                ? intl.formatMessage({ id: validateResults.note.message }, { maxLength: 255 }) : ''}
                        />
                    </div>

                </GridItem>

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography required bold>
                            開催場所
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.address}
                            isMultiline
                            onChange={(value) => handleSetParams('address', value)}
                            error={!!validateResults.address}
                            helperText={validateResults.address
                                ? intl.formatMessage({ id: validateResults.address.message }) : ''}
                        />
                    </div>

                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography required bold>
                            概要
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.description}
                            isMultiline
                            onChange={(value) => handleSetParams('description', value)}
                            error={!!validateResults.description}
                            helperText={validateResults.description
                                ? intl.formatMessage({ id: validateResults.description.message }, { maxLength: 1000 }) : ''}
                        />
                    </div>

                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle} style={{ marginBottom: '15px' }}>
                        <CustomTypography bold>
                            レイアウト選択
                        </CustomTypography>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitleItem}>
                        <CustomTypography bold>
                            出展参加者情報一覧
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="exhibitions"
                            name="exhibitions"
                            value={params.layoutExhibition}
                            onChange={(e) => setParams({
                                ...params,
                                layoutExhibition: +e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={layoutExhibitionValue.default}
                                control={<Radio color="primary" checked={params.layoutExhibition === 0} />}
                                label="元レイアウト"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={layoutExhibitionValue.layoutFirst}
                                control={<Radio color="primary" checked={params.layoutExhibition === 1} />}
                                label="レイアウト１"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitleItem}>
                        <CustomTypography bold>
                            セミナー一覧
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="exhibitions"
                            name="exhibitions"
                            value={params.layoutSeminar}
                            onChange={(e) => setParams({
                                ...params,
                                layoutSeminar: +e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={layoutSeminarValue.default}
                                control={<Radio color="primary" checked={params.layoutSeminar === 0} />}
                                label="元レイアウト"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={layoutSeminarValue.layoutFirst}
                                control={<Radio color="primary" checked={params.layoutSeminar === 1} />}
                                label="レイアウト１"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitleItem}>
                        <CustomTypography bold>
                            ライブ配信
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="exhibitions"
                            name="exhibitions"
                            value={params.layoutLivestream}
                            onChange={(e) => setParams({
                                ...params,
                                layoutLivestream: +e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={layoutLivestreamValue.default}
                                control={<Radio color="primary" checked={params.layoutLivestream === 0} />}
                                label="元レイアウト"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={layoutLivestreamValue.layoutFirst}
                                control={<Radio color="primary" checked={params.layoutLivestream === 1} />}
                                label="レイアウト１"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitleItem}>
                        <CustomTypography bold>
                            サイドバー
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="exhibitions"
                            name="exhibitions"
                            value={params.layoutSidebar}
                            onChange={(e) => setParams({
                                ...params,
                                layoutSidebar: +e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={layoutSidebarValue.default}
                                control={<Radio color="primary" checked={params.layoutSidebar === 0} />}
                                label="元レイアウト"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={layoutSidebarValue.layoutFirst}
                                control={<Radio color="primary" checked={params.layoutSidebar === 1} />}
                                label="レイアウト１"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            カスタムモードを行うか？
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="exhibitions"
                            name="exhibitions"
                            value={params.hasCustom}
                            onChange={(e) => setParams({
                                ...params,
                                hasCustom: e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={exhibitionsValue.yes}
                                control={<Radio color="primary" checked={params.hasCustom === '1'} disabled={!_.isEmpty(eventDetail)} />}
                                label="する"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={exhibitionsValue.no}
                                control={<Radio color="primary" checked={params.hasCustom === '0'} disabled={!_.isEmpty(eventDetail)} />}
                                label="しない"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            多言語機能
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        {LIST_LANGUAGE.map((item) => (
                            <FormControlLabel
                                className={classes.checkBox}
                                control={(
                                    <Checkbox
                                        disabled={!_.isEmpty(eventDetail)}
                                        color="primary"
                                        checked={listLanguage[item.language]}
                                        onChange={(check) => handleChangeValueLanguage(item.language, check.target.checked)}
                                    />
                                )}
                                label={item.text}
                            />
                        ))}
                    </div>
                </GridItem>
                
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                        展示エリア（分類/カテゴリ）
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <Autocomplete
                            multiple
                            freeSolo
                            id="tags-outlined"
                            options={[]}
                            value={autoCompleteValueCate}
                            onChange={(e, val) => {
                                setAutoCompleteValueCate(val);
                            }}
                            renderTags={(val, getTagProps) => val.map((option, index) => (
                                <Chip variant="outlined" color="primary" label={option} {...getTagProps({ index })} />
                            ))}
                            renderInput={(p) => (
                                <TextField
                                    {...p}
                                    variant="outlined"
                                    placeholder="展示エリア"
                                    size="small"
                                    onKeyDown={(e) => {
                                        if (([TAB, ENTER, SPACE].includes(e.keyCode)) && e.target.value.trim()) {
                                            setAutoCompleteValueCate(autoCompleteValueCate.concat(e.target.value));
                                        }
                                    }}
                                />
                            )}
                        />

                    </div>
                </GridItem>


                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography required bold>
                            展示会を開催しますか？
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="exhibitions"
                            name="exhibitions"
                            value={params.hasExhibition}
                            onChange={(e) => setParams({
                                ...params,
                                hasExhibition: e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={exhibitionsValue.yes}
                                control={<Radio color="primary" checked={params.hasExhibition === '1'} disabled={params.isExhibition} />}
                                label="する"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={exhibitionsValue.no}
                                control={<Radio color="primary" checked={params.hasExhibition === '0'} disabled={params.isExhibition} />}
                                label="しない"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>
                {params.hasExhibition === '1' && (
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle}>
                            <CustomTypography bold>
                                出展企業一覧を公開するか？
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                            <RadioGroup
                                aria-label="displayExhibition"
                                name="displayExhibition"
                                value={params.displayExhibition}
                                onChange={(e) => setParams({
                                    ...params,
                                    displayExhibition: e.target.value,
                                })}
                                row
                            >
                                <FormControlLabel
                                    value={exhibitionsValue.yes}
                                    control={<Radio color="primary" checked={params.displayExhibition === '1'} />}
                                    label="する"
                                    className={classes.radioButton}
                                />
                                <FormControlLabel
                                    value={exhibitionsValue.no}
                                    control={<Radio color="primary" checked={params.displayExhibition === '0'} />}
                                    label="しない"
                                    className={classes.radioButton}
                                />
                            </RadioGroup>
                        </div>
                    </GridItem>
                )}
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography required bold>
                            セミナーを開催しますか？
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="seminar"
                            name="seminar"
                            value={params.seminar}
                            onChange={(e) => setParams({
                                ...params,
                                hasSeminar: e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={seminarValue.yes}
                                control={<Radio color="primary" checked={params.hasSeminar === '1'} disabled={params.isSeminar} />}
                                label="する"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={seminarValue.no}
                                control={<Radio color="primary" checked={params.hasSeminar === '0'} disabled={params.isSeminar} />}
                                label="しない"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>
                {params.hasSeminar === '1' && (
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle}>
                            <CustomTypography bold>
                                セミナー一覧を公開するか？
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                            <RadioGroup
                                aria-label="displaySeminar"
                                name="displaySeminar"
                                value={params.displaySeminar}
                                onChange={(e) => setParams({
                                    ...params,
                                    displaySeminar: e.target.value,
                                })}
                                row
                            >
                                <FormControlLabel
                                    value={seminarValue.yes}
                                    control={<Radio color="primary" checked={params.displaySeminar === '1'} />}
                                    label="する"
                                    className={classes.radioButton}
                                />
                                <FormControlLabel
                                    value={seminarValue.no}
                                    control={<Radio color="primary" checked={params.displaySeminar === '0'} />}
                                    label="しない"
                                    className={classes.radioButton}
                                />
                            </RadioGroup>
                        </div>
                    </GridItem>
                )}

                {/* Item Live Stream */}
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            ライブ配信を開催しますか？
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="hasLiveStream"
                            name="hasLiveStream"
                            value={params.hasLiveStream}
                            onChange={(e) => setParams({
                                ...params,
                                hasLiveStream: e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={liveStreamValue.yes}
                                control={<Radio color="primary" checked={params.hasLiveStream === '1'} disabled={params.isLiveStream} />}
                                label="する"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={liveStreamValue.no}
                                control={<Radio color="primary" checked={params.hasLiveStream === '0'} disabled={params.isLiveStream} />}
                                label="しない"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                        {params.hasLiveStream === '1' && (
                            <TextField
                                variant="outlined"
                                value={params.price_live_stream}
                                className={classes.name}
                                onChange={(event) => handleSetParams('price_live_stream', _.toNumber(event.target.value) || '')}
                                inputProps={{
                                    min: 0,
                                }}
                                InputProps={{ classes: { root: `${classes.numberInputPriceLiveStream} ${classes.price}` } }}
                            />
                        )}
                    </div>
                </GridItem>

                {/* Item Public Live Stream */}
                {params.hasLiveStream === '1' && (
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle}>
                            <CustomTypography bold>
                                ライブ配信一覧を公開しますか？
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                            <RadioGroup
                                aria-label="hasLiveStream"
                                name="hasLiveStream"
                                value={params.hasLiveStream}
                                onChange={(e) => setParams({
                                    ...params,
                                    displayLiveStream: e.target.value,
                                })}
                                row
                            >
                                <FormControlLabel
                                    value={freeLoginValue.yes}
                                    control={<Radio color="primary" checked={params.displayLiveStream === '1'} />}
                                    label="する"
                                    className={classes.radioButton}
                                />
                                <FormControlLabel
                                    value={freeLoginValue.no}
                                    control={<Radio color="primary" checked={params.displayLiveStream === '0'} />}
                                    label="しない"
                                    className={classes.radioButton}
                                />
                            </RadioGroup>
                        </div>
                    </GridItem>
                )}

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle} />
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        {
                            validateResults.hasNoApplications && validateResults.hasNoApplications.result !== 'success' && (
                                <CustomTypography color="danger" style={{ fontSize: '0.75rem', marginLeft: '15px' }}>
                                    {validateResults.hasNoApplications
                                        ? intl.formatMessage({ id: validateResults.hasNoApplications.message }) : ''}
                                </CustomTypography>
                            )
                        }
                    </div>
                </GridItem>

                {/* Item Free Login Booth */}
                {params.hasExhibition === '1' && (
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle}>
                            <CustomTypography bold required>
                                展示会のフリー入場
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                            <RadioGroup
                                aria-label="free_exhibition"
                                name="free_exhibition"
                                value={params.free_exhibition}
                                onChange={(e) => setParams({
                                    ...params,
                                    free_exhibition: e.target.value,
                                })}
                                row
                            >
                                <FormControlLabel
                                    value={freeLoginValue.yes}
                                    control={<Radio color="primary" checked={params.free_exhibition === '1'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                    label="する"
                                    className={classes.radioButton}
                                />
                                <FormControlLabel
                                    value={freeLoginValue.no}
                                    control={<Radio color="primary" checked={params.free_exhibition === '0'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                    label="しない"
                                    className={classes.radioButton}
                                />
                            </RadioGroup>
                        </div>
                    </GridItem>
                )}

                {/* Item Free Login Seminar */}
                {params.hasSeminar === '1' && (
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle}>
                            <CustomTypography bold required>
                                セミナーのフリー入場
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                            <RadioGroup
                                aria-label="free_seminar"
                                name="free_seminar"
                                value={params.free_seminar}
                                onChange={(e) => setParams({
                                    ...params,
                                    free_seminar: e.target.value,
                                })}
                                row
                            >
                                <FormControlLabel
                                    value={freeLoginValue.yes}
                                    control={<Radio color="primary" checked={params.free_seminar === '1'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                    label="する"
                                    className={classes.radioButton}
                                />
                                <FormControlLabel
                                    value={freeLoginValue.no}
                                    control={<Radio color="primary" checked={params.free_seminar === '0'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                    label="しない"
                                    className={classes.radioButton}
                                />
                            </RadioGroup>
                        </div>
                    </GridItem>
                )}

                {/* Item Free Login Live Stream */}
                {params.hasLiveStream === '1' && (
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle}>
                            <CustomTypography bold required>
                                ライブ配信のフリー入場
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                            <RadioGroup
                                aria-label="free_live_stream"
                                name="free_live_stream"
                                value={params.free_live_stream}
                                onChange={(e) => setParams({
                                    ...params,
                                    free_live_stream: e.target.value,
                                })}
                                row
                            >
                                <FormControlLabel
                                    value={freeLoginValue.yes}
                                    control={<Radio color="primary" checked={params.free_live_stream === '1'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                    label="する"
                                    className={classes.radioButton}
                                />
                                <FormControlLabel
                                    value={freeLoginValue.no}
                                    control={<Radio color="primary" checked={params.free_live_stream === '0'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                    label="しない"
                                    className={classes.radioButton}
                                />
                            </RadioGroup>
                        </div>
                    </GridItem>
                )}
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            ショッピングカートの使用
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="has_shopping_cart"
                            name="has_shopping_cart"
                            value={params.has_shopping_cart}
                            onChange={(e) => setParams({
                                ...params,
                                has_shopping_cart: e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={hasShoppingCart.yes}
                                control={<Radio color="primary" checked={params.has_shopping_cart === '1'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                label="する"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={hasShoppingCart.no}
                                control={<Radio color="primary" checked={params.has_shopping_cart === '0'} {...!_.isEmpty(eventDetail) && { disabled: true }} />}
                                label="しない"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography required bold>
                            広告
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <RadioGroup
                            aria-label="displayAds"
                            name="displayAds"
                            value={params.displayAds}
                            onChange={(e) => setParams({
                                ...params,
                                displayAds: e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value={seminarValue.yes}
                                control={<Radio color="primary" checked={params.displayAds === '1'} />}
                                label="する"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value={seminarValue.no}
                                control={<Radio color="primary" checked={params.displayAds === '0'} />}
                                label="しない"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>

                {renderZoneArea()}

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            ブース種別
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <FormControlLabel
                            className={classes.checkBox}
                            control={(
                                <Checkbox
                                    disabled={params.hasExhibition === '0'}
                                    color="primary"
                                    checked={params.smallzone}
                                    onChange={(check) => handleSetParams('smallzone', check.target.checked)}
                                />
                            )}
                            label={intl.formatMessage({ id: 'adminSettingBooth.smallZone' })}
                        />
                        <FormControlLabel
                            className={classes.checkBox}
                            control={(
                                <Checkbox
                                    disabled={params.hasExhibition === '0'}
                                    color="primary"
                                    checked={params.standardzone}
                                    onChange={(check) => handleSetParams('standardzone', check.target.checked)}
                                />
                            )}
                            label={intl.formatMessage({ id: 'adminSettingBooth.standardZone' })}
                        />
                        <FormControlLabel
                            className={classes.checkBox}
                            control={(
                                <Checkbox
                                    disabled={params.hasExhibition === '0'}
                                    color="primary"
                                    checked={params.bigzone}
                                    onChange={(check) => handleSetParams('bigzone', check.target.checked)}
                                />
                            )}
                            label={intl.formatMessage({ id: 'adminSettingBooth.bigZone' })}
                        />
                        {params.has_shopping_cart === '1' && (
                            <FormControlLabel
                                className={classes.checkBox}
                                control={(
                                    <Checkbox
                                        disabled={params.hasExhibition === '0'}
                                        color="primary"
                                        checked={params.grandZone}
                                        onChange={(check) => handleSetParams('grandZone', check.target.checked)}
                                    />
                                )}
                                label={intl.formatMessage({ id: 'adminSettingBooth.grandZone' })}
                            />
                        )}
                        {
                            validateResults.checkBox && validateResults.checkBox.result !== 'success' && (
                                <CustomTypography color="danger" style={{ fontSize: '0.75rem', marginLeft: '15px' }}>
                                    {validateResults.checkBox
                                        ? intl.formatMessage({ id: validateResults.checkBox.message }) : ''}
                                </CustomTypography>
                            )
                        }
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={`${classes.item} ${classes.time}`}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            展示会の最大ビデオ時間
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <TextField
                            disabled={params.hasExhibition === '0'}
                            variant="outlined"
                            type="number"
                            className={classes.input}
                            value={params.maxVideoTimeExhibition}
                            onChange={(event) => handleSetParams('maxVideoTimeExhibition', _.toNumber(event.target.value) || '')}
                            onKeyPress={handleKeyPressInput}
                            inputProps={{
                                min: 0,
                            }}
                            InputProps={{ classes: { root: classes.numberInput } }}
                            error={!!validateResults.maxVideoTimeExhibition}
                            helperText={validateResults.maxVideoTimeExhibition
                                ? intl.formatMessage({ id: validateResults.maxVideoTimeExhibition.message }) : ''}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={`${classes.item} ${classes.time}`}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            展示会の最大オーディオ時間
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <TextField
                            disabled={params.hasExhibition === '0'}
                            variant="outlined"
                            type="number"
                            className={classes.input}
                            value={params.maxAudioTimeExhibition}
                            onChange={(event) => handleSetParams('maxAudioTimeExhibition', _.toNumber(event.target.value) || '')}
                            onKeyPress={handleKeyPressInput}
                            inputProps={{
                                min: 0,
                            }}
                            InputProps={{ classes: { root: classes.numberInput } }}
                            error={!!validateResults.maxAudioTimeExhibition}
                            helperText={validateResults.maxAudioTimeExhibition
                                ? intl.formatMessage({ id: validateResults.maxAudioTimeExhibition.message }) : ''}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={`${classes.item} ${classes.time}`}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            セミナーの最大ビデオ時間
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <TextField
                            disabled={params.hasSeminar === '0'}
                            variant="outlined"
                            type="number"
                            className={classes.input}
                            value={params.maxVideoTimeSeminar}
                            onChange={(event) => handleSetParams('maxVideoTimeSeminar', _.toNumber(event.target.value) || '')}
                            onKeyPress={handleKeyPressInput}
                            inputProps={{
                                min: 0,
                            }}
                            InputProps={{ classes: { root: classes.numberInput } }}
                            error={!!validateResults.maxVideoTimeSeminar}
                            helperText={validateResults.maxVideoTimeSeminar
                                ? intl.formatMessage({ id: validateResults.maxVideoTimeSeminar.message }) : ''}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={`${classes.item} ${classes.time}`}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            セミナーの最大オーディオ時間
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <TextField
                            disabled={params.hasSeminar === '0'}
                            variant="outlined"
                            type="number"
                            className={classes.input}
                            value={params.maxAudioTimeSeminar}
                            onChange={(event) => handleSetParams('maxAudioTimeSeminar', _.toNumber(event.target.value) || '')}
                            onKeyPress={handleKeyPressInput}
                            inputProps={{
                                min: 0,
                            }}
                            InputProps={{ classes: { root: classes.numberInput } }}
                            error={!!validateResults.maxAudioTimeSeminar}
                            helperText={validateResults.maxAudioTimeSeminar
                                ? intl.formatMessage({ id: validateResults.maxAudioTimeSeminar.message }) : ''}
                        />
                    </div>
                </GridItem>

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            事務局名
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.event_organizer_name}
                            isMultiline
                            onChange={(value) => handleSetParams('event_organizer_name', value)}
                            error={!!validateResults.event_organizer_name}
                            helperText={validateResults.event_organizer_name
                                ? intl.formatMessage({ id: validateResults.event_organizer_name.message }, { maxLength: 255 }) : ''}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            事務局TEL
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            defaultValue={params.event_organizer_tel}
                            onChange={(valueInput) => handleSetParams('event_organizer_tel', valueInput)}
                            error={!!validateResults.event_organizer_tel}
                            helperText={validateResults.event_organizer_tel
                                ? intl.formatMessage(
                                    { id: validateResults.event_organizer_tel.message },
                                ) : ''}
                        />
                        <CustomTypography className={classes.right}>
                            記入例：045-912-2112 → 0459122112 と入力
                        </CustomTypography>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            事務局Email
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.event_organizer_email}
                            isMultiline
                            onChange={(value) => handleSetParams('event_organizer_email', value)}
                            error={!!validateResults.event_organizer_email}
                            helperText={validateResults.event_organizer_email
                                ? intl.formatMessage({ id: validateResults.event_organizer_email.message }) : ''}
                        />
                    </div>
                </GridItem>

                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            出展募集要項
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.organizationRequestUrl}
                            isMultiline
                            onChange={(value) => handleSetParams('organizationRequestUrl', value)}
                            error={!!validateResults.organization}
                            helperText={validateResults.organization
                                ? intl.formatMessage({ id: validateResults.organization.message }, { maxLength: 255 }) : ''}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            出展者の業種
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <Autocomplete
                            multiple
                            freeSolo
                            id="tags-outlined"
                            options={[]}
                            value={autoCompleteValue}
                            onChange={(e, val) => {
                                setAutoCompleteValue(val);
                            }}
                            renderTags={(val, getTagProps) => val.map((option, index) => (
                                <Chip variant="outlined" color="primary" label={option} {...getTagProps({ index })} />
                            ))}
                            renderInput={(p) => (
                                <TextField
                                    {...p}
                                    variant="outlined"
                                    placeholder="出展者の業種"
                                    size="small"
                                    onKeyDown={(e) => {
                                        if (([TAB, ENTER, SPACE].includes(e.keyCode)) && e.target.value.trim()) {
                                            setAutoCompleteValue(autoCompleteValue.concat(e.target.value));
                                        }
                                    }}
                                    error={!!validateResults.jobs}
                                />
                            )}
                        />
                        <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                            {validateResults.jobs && validateResults.jobs.result
                                ? intl.formatMessage({ id: validateResults.jobs.message }) : ''}
                        </FormHelperText>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            入場者の業種
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <Autocomplete
                            multiple
                            freeSolo
                            id="tags-outlined-viewer"
                            options={[]}
                            value={autoCompleteValueJobViewer}
                            onChange={(e, val) => {
                                setAutoCompleteValueJobViewer(val);
                            }}
                            renderTags={(val, getTagProps) => val.map((option, index) => (
                                <Chip variant="outlined" color="primary" label={option} {...getTagProps({ index })} />
                            ))}
                            renderInput={(p) => (
                                <TextField
                                    {...p}
                                    variant="outlined"
                                    placeholder="入場者の業種"
                                    size="small"
                                    onKeyDown={(e) => {
                                        if (([TAB, ENTER, SPACE].includes(e.keyCode)) && e.target.value.trim()) {
                                            setAutoCompleteValueJobViewer(autoCompleteValueJobViewer.concat(e.target.value));
                                        }
                                    }}
                                    error={!!validateResults.jobs_viewer}
                                />
                            )}
                        />
                        <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                            {validateResults.jobs_viewer && validateResults.jobs_viewer.result
                                ? intl.formatMessage({ id: validateResults.jobs_viewer.message }) : ''}
                        </FormHelperText>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            出展者の職種
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <Autocomplete
                            multiple
                            freeSolo
                            id="tags-outlined-viewer"
                            options={[]}
                            value={autoCompleteValueOccupationOrganizer}
                            onChange={(e, val) => {
                                setAutoCompleteValueOccupationOrganizer(val);
                            }}
                            renderTags={(val, getTagProps) => val.map((option, index) => (
                                <Chip variant="outlined" color="primary" label={option} {...getTagProps({ index })} />
                            ))}
                            renderInput={(p) => (
                                <TextField
                                    {...p}
                                    variant="outlined"
                                    placeholder="出展者の職種"
                                    size="small"
                                    onKeyDown={(e) => {
                                        if (([TAB, ENTER, SPACE].includes(e.keyCode)) && e.target.value.trim()) {
                                            setAutoCompleteValueOccupationOrganizer(autoCompleteValueOccupationOrganizer.concat(e.target.value));
                                        }
                                    }}
                                    error={!!validateResults.occupation_organizer}
                                />
                            )}
                        />
                        <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                            {validateResults.occupation_organizer && validateResults.occupation_organizer.result
                                ? intl.formatMessage({ id: validateResults.occupation_organizer.message }) : ''}
                        </FormHelperText>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            入場者の職種
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <Autocomplete
                            multiple
                            freeSolo
                            id="tags-outlined"
                            options={[]}
                            value={autoCompleteValueOccupationViewer}
                            onChange={(e, val) => {
                                setAutoCompleteValueOccupationViewer(val);
                            }}
                            renderTags={(val, getTagProps) => val.map((option, index) => (
                                <Chip variant="outlined" color="primary" label={option} {...getTagProps({ index })} />
                            ))}
                            renderInput={(p) => (
                                <TextField
                                    {...p}
                                    variant="outlined"
                                    placeholder="入場者の職種"
                                    size="small"
                                    onKeyDown={(e) => {
                                        if (([TAB, ENTER, SPACE].includes(e.keyCode)) && e.target.value.trim()) {
                                            setAutoCompleteValueOccupationViewer(autoCompleteValueOccupationViewer.concat(e.target.value));
                                        }
                                    }}
                                    error={!!validateResults.occupation_viewer}
                                />
                            )}
                        />
                        <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                            {validateResults.occupation_viewer && validateResults.occupation_viewer.result
                                ? intl.formatMessage({ id: validateResults.occupation_viewer.message }) : ''}
                        </FormHelperText>
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item} style={{ alignItems: 'baseline' }}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold required>
                            ロゴ画像
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                        <UploadButton
                            type="image"
                            text="Upload an Image"
                            onChange={(value) => handleUploadImage(value)}
                            imagePreview={params.image}
                        />
                        {
                            validateResults.image && validateResults.image.result !== 'success' && (
                                <CustomTypography color="danger" style={{ fontSize: '0.75rem', marginLeft: '15px' }}>
                                    {validateResults.image
                                        ? intl.formatMessage({ id: validateResults.image.message }) : ''}
                                </CustomTypography>
                            )
                        }
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            リアル展示会コンバート機能ONサーバー
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.outer_server_activation}
                            isMultiline
                            onChange={(value) => handleSetParams('outer_server_activation', value)}
                            error={!!validateResults.outer_server_activation}
                            helperText={validateResults.outer_server_activation
                                ? intl.formatMessage({ id: validateResults.outer_server_activation.message }, { maxLength: 255 }) : ''}
                        />
                        <CustomTypography style={{ marginTop: '-10px' }}>
                            外部サーバーのリンクは、サーバーのドメインまたはIPを入力してください。
                            <br />
                            例：oes.com、211.100.100.101など
                        </CustomTypography>
                    </div>
                </GridItem>
            </WrapperContainer>

            <SnackBar
                open={isOpenSnackBar}
                onClose={() => setIsOpenSnackBar(false)}
                message={errorMsg}
                severity="error"
                autoHideDuration={3000}
            />
        </FormDialog>
    );
}
EventDialog.defaultProps = {
    createSuccess: false,
    createErrors: {},
    editSuccess: false,
    editErrors: {},
    getDetailEvent: {},
    fetchCreateEvent: () => { },
    fetchEditEvent: () => { },
    fetchClearCreateEvent: () => { },
    fetchClearEditEvent: () => { },
    fetchGetDetailEvent: () => { },
    eventId: 0,
    dataAccount: {},
    fetchClearGetDetailEvent: () => {},
};

EventDialog.propTypes = {
    createSuccess: PropTypes.bool,
    createErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    editSuccess: PropTypes.bool,
    editErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    getDetailEvent: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchCreateEvent: PropTypes.func,
    fetchEditEvent: PropTypes.func,
    fetchClearCreateEvent: PropTypes.func,
    fetchClearEditEvent: PropTypes.func,
    fetchGetDetailEvent: PropTypes.func,
    eventId: PropTypes.number,
    eventShortName: PropTypes.oneOfType([null, PropTypes.number]).isRequired,
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    clearEventZone: PropTypes.func.isRequired,
    zonesStatus: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    fetchEventZones: PropTypes.func.isRequired,
    eventZones: PropTypes.oneOfType([null, PropTypes.array]).isRequired,
    dataAccount: PropTypes.oneOfType([() => null, PropTypes.object]),
    role: PropTypes.number.isRequired,
    fetchClearGetDetailEvent: PropTypes.func,
};
